import React from "react";
import { arrayOf, func, number, instanceOf, objectOf, shape, string, bool, array } from 'prop-types';
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { connect } from "react-redux";
import { CircularProgress, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import HelpIcon from "@material-ui/icons/Help";
import Slide from "@material-ui/core/Slide";
import Typography from "@material-ui/core/Typography";
import cx from "classnames";
// import { Notifier } from "veritone-react-common";
import _, { get, isEmpty } from 'lodash';
import styles from "./styles.scss";
import { configPropTypes } from "./types";
import AdvertiserContent from "./AdvertiserContent";
import {
    addAdvertiser,
    addAdvertiserSaga,
    getAdvertiser,
    getAdvertisers,
    getAdvertiserSaga,
    getStationSaga,
    nextStepSaga,
    setStep,
    updateAdvertiser,
    updateAdvertiserSaga,
    removeAdvertiser,
    Status
} from "../../state/modules/app/advertiser";
import { goToManageConnections } from '../../state/modules/routing/actions';
import { getFolderEditing, toggleFolderModal } from "state/modules/app/folder";
import { getAppSettingSaga } from "../../state/modules/app/appSetting";
import { getAttributionFolder } from "state/modules/app/mentions";
import getEngineSearch from "../../helpers/getEngineSearch";
import getApiRoot from "../../helpers/getApiRoot";
import getUrlApi from "../../helpers/getUrlApi";
import constants from "./constants";
import { getPendo, getSegment } from "../../helpers/analyticsHelper";
import { actionReloadFilePicker } from "state/modules/filePicker";
import { ADVERTISER_INVITE_TAB, ADVERTISER_DETAIL_TAB, STATUS_ENGINE_ERROR, TRACKING_SOURCE_NAME } from "../../helpers/constant";
import { reProcessSaga, removeVisualRefreshDataSaga, selectVisualRefreshData } from "../../state/modules/app/visualDataRefresh";
import { modules } from 'veritone-redux-common';
import { getEmailTemplateSaga } from "../../state/modules/app/emailTemplate";

const { user: { selectUser } } = modules;

const Transition = (props) => <Slide direction="down" {...props} />;

const MUIstyles = {
    dialogTitle: {
        height: 60
    },
    appBar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexFlow: "row nowrap",
        padding: "0 1.5rem",
        height: 60,
        boxShadow: "none",
        backgroundColor: '#3A3A3A',
    },
    dialogContent: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingBottom: 0
    },
    advertiserBody: {
        padding: 20
    },
    icon: {
        color: "#A8A8A8"
    }
};

@connect(state => {
    const isConnectionsOriginator = get(state, 'location.prev.payload.isConnectionsOriginator', false);

    return ({
        visualDataRefresh: selectVisualRefreshData(state),
        advertiserId: state.location.payload.advertiserId,
        sessionToken: state.auth.sessionToken,
        getAdvertiser: getAdvertiser(state),
        advertisers: getAdvertisers(state),
        attributionFolder: getAttributionFolder(state),
        engineSearch: getEngineSearch(state),
        apiRoot: getApiRoot(state),
        editingFolder: getFolderEditing(state),
        urlApi: getUrlApi(state),
        segment: getSegment(state),
        pendo: getPendo(state),
        roles: state.app.roles,
        appSetting: state.appSetting,
        currentTab: state.location.payload.tab,
        currentUser: selectUser(state),
        isConnectionsOriginator,
        emailTemplate: state.emailTemplate,
    })
}, (dispatch) => ({
    reProcessSaga: compose(dispatch, reProcessSaga),
    removeVisualRefreshDataSaga: compose(dispatch, removeVisualRefreshDataSaga),
    getStationSaga: compose(dispatch, getStationSaga),
    getAdvertiserSaga: compose(dispatch, getAdvertiserSaga),
    addAdvertiserSaga: compose(dispatch, addAdvertiserSaga),
    addAdvertiser: compose(dispatch, addAdvertiser),
    updateAdvertiser: compose(dispatch, updateAdvertiser),
    updateAdvertiserSaga: compose(dispatch, updateAdvertiserSaga),
    nextStepSaga: compose(dispatch, nextStepSaga),
    setStep: compose(dispatch, setStep),
    toggleFolderModal: compose(dispatch, toggleFolderModal),
    getAppSettingSaga: compose(dispatch, getAppSettingSaga),
    reloadFilePicker: compose(dispatch, actionReloadFilePicker),
    removeAdvertiser: compose(dispatch, removeAdvertiser),
    goToManageConnections: compose(dispatch, goToManageConnections),
    getEmailTemplate: compose(dispatch, getEmailTemplateSaga),
    onClose: () => dispatch({
        type: "route/ROUTE_HOME"
    }),
    redirect: (advertiserId) => dispatch({
        type: "router/ROUTE_ADVERTISER_DETAIL",
        payload: {
            advertiserId
        }
    }),
    redirectAdvertiserTab: (advertiserId, tab) => dispatch({
        type: "route/ROUTE_ADVERTISER_EDIT_TAB",
        payload: {
            advertiserId,
            tab
        }
    })
}))
@withStyles(MUIstyles)

class Advertiser extends React.Component {

    static propTypes = {
        classes: objectOf(string),
        getStationSaga: func,
        advertiserId: number,
        getAdvertiserSaga: func,
        addAdvertiser: func,
        addAdvertiserSaga: func,
        updateAdvertiser: func,
        setStep: func,
        getAdvertiser: func,
        attributionFolder: shape({
            id: string,
            name: string
        }),
        appSetting: instanceOf(Object),
        roles: arrayOf(objectOf(string)),
        sessionToken: string,
        nextStepSaga: func,
        updateAdvertiserSaga: func,
        redirect: func,
        toggleFolderModal: func,
        editingFolder: shape({
            folder_id: string.isRequired
        }),
        onClose: func,
        visualDataRefresh: shape({
            currentData: arrayOf(shape({
                id: string,
                type: string,
                description1: string,
                description2: string
            }))
        }),
        currentUser: shape({
            organization: shape({
                kvp: shape({
                    features: shape({
                        beta: string
                    })
                })
            })
        }),
        isConnectionsOriginator: bool,
        goToManageConnections: func,
        attributeLabel: string,
        newAdvertiserTitle: string,
        editAdvertiserTitle: string,
        emailTemplate: shape({
            data: array,
            status: string
        }),
        ...configPropTypes
    };
    
    static defaultProps = {
        attributeLabel: 'Attribute',
        newAdvertiserTitle: 'New Advertiser',
        editAdvertiserTitle: 'Advertiser Settings',
    }

    componentDidMount() {
        const {
          advertiserId,
          getAdvertiserSaga,
          addAdvertiser,
          setStep,
          getAppSettingSaga,
          appSetting,
          currentTab,
          redirectAdvertiserTab,
          emailTemplate:{
            status: emailTemplateStatus,
          },
          getEmailTemplate
        } = this.props;


        if(!currentTab && advertiserId) {
            redirectAdvertiserTab(advertiserId, ADVERTISER_DETAIL_TAB)
        }
        if(isEmpty(appSetting)) {
            getAppSettingSaga();
        }
        if (advertiserId) {
            getAdvertiserSaga(advertiserId, currentTab);
        } else {
            addAdvertiser({ advertiser_id: "editing", activeStep: 0, loading: false, loaded: true });
        }

        if (emailTemplateStatus && emailTemplateStatus !== Status.STATUS_LOADED) {
          getEmailTemplate && getEmailTemplate();
        }

        setStep(constants.advertiserSteps.ADVERTISER_DETAILS);
    }

    componentWillUnmount = () => {
        this.props.removeAdvertiser(this.advertiser);
    }

    onBack = () => {
        const { activeStep } = this.advertiser;
        this.props.setStep(activeStep - 1);
    };

    handleAdvertiserCreate = () => {
        const { addAdvertiserSaga } = this.props;

        addAdvertiserSaga && addAdvertiserSaga(this.advertiser)
    }

    handleAdvertiserUpdate = (isEmailInfoRequired) => {
        const { updateAdvertiserSaga, advertiserId, getAdvertiser } = this.props;
        updateAdvertiserSaga && updateAdvertiserSaga({
              ...this.advertiser,
              advertiser_id: advertiserId
          },
          getAdvertiser(advertiserId),
          isEmailInfoRequired
        );
    }

    onCancel = () => {
        const { advertiserId, onClose, redirect, isConnectionsOriginator, goToManageConnections } = this.props;
        if (isConnectionsOriginator) {
            goToManageConnections && goToManageConnections();
            return;
        }
        if (advertiserId) {
            redirect && redirect(advertiserId);
        } else {
            onClose && onClose();
        }
    };

    onSetTab = (event, activeStep) => {
        const { redirectAdvertiserTab, advertiserId } = this.props
        activeStep === 1 ? redirectAdvertiserTab(advertiserId, ADVERTISER_INVITE_TAB) : redirectAdvertiserTab(advertiserId, ADVERTISER_DETAIL_TAB)
        this.props.setStep(activeStep);
    };

    onNext = () => {
        const { activeStep } = this.advertiser;
        const { nextStepSaga } = this.props;
        if (activeStep === 1) {
            this.props.addAdvertiserSaga(this.advertiser);
        } else {
            nextStepSaga(this.advertiser);
        }
    };

    get advertiser() {
        const { getAdvertiser, advertiserId } = this.props;
        const advertiser = getAdvertiser('editing') || { advertiser_id: 'editing', activeStep: 0 };

        // pass the current advertiserId in case the user wants to delete
        // the advertiser if the expiration date is over 30 days.
        return {
            ...advertiser,
            advertiser_id: 'editing',
            deleteId: advertiserId
        }
    }

    onActionClick = data => event => {
        this.props.reProcessSaga(data);
    }

    onRemoveClick = data => event => {
        this.props.removeVisualRefreshDataSaga(data);
    }

    render() {
        const {
            classes,
            getStationSaga,
            advertiserId,
            attributionFolder,
            engineSearch,
            apiRoot,
            urlApi,
            getAdvertiser,
            updateAdvertiser,
            toggleFolderModal,
            editingFolder,
            sessionToken,
            roles,
            appSetting,
            reloadFilePicker,
            visualDataRefresh,
            currentUser,
            attributeLabel,
            newAdvertiserTitle,
            editAdvertiserTitle,
            emailTemplate,
        } = this.props;
        const displayMultiMarkets = _.get(currentUser, 'organization.kvp.features.attribute.advertiserInMultipleMarkets', 'disabled') === 'enabled';
        const loaded = _.get(getAdvertiser(advertiserId), "loaded", false);
        const currentData = _.get(visualDataRefresh, "currentData", []);
        const oldAdvertiser = getAdvertiser(advertiserId) || {};
        const advertiser = this.advertiser;
        const isWebUploadAdvertiser = advertiser.trackingDataSourceName === TRACKING_SOURCE_NAME.WEB_UPLOAD;
        const isChangeConnectionType = oldAdvertiser.trackingDataSourceName !== advertiser.trackingDataSourceName;
        const isSendInvite = isChangeConnectionType && !isWebUploadAdvertiser;
       
        const notifications = currentData.map(data => {
            return {
                ...data,
                onActionClick: data.status_engine === STATUS_ENGINE_ERROR ? this.onActionClick(data) : undefined,
                onRemoveClick: data.status_engine === STATUS_ENGINE_ERROR ? this.onRemoveClick(data) : undefined
            }
        });
        return (
            <Dialog
                fullScreen
                open
                disableEnforceFocus
                onClose={this.onCancel}
                TransitionComponent={Transition}
            >
                <DialogTitle className={classes.dialogTitle}>
                    <AppBar
                        position="fixed"
                        className={cx(classes.appBar, styles.appBarContainer)}
                        color="secondary"
                    >
                        <Typography
                            variant="h1"
                            color="inherit"
                            className={cx(styles.title)}
                        >
                            {attributeLabel}
                        </Typography>
                        <div className={cx(styles["div-button"])}>
                            {/* <Notifier notifications={notifications} /> */}
                            <a href="https://help.veritone.com/veritone-attribute" rel="noopener noreferrer" target="_blank">
                                <IconButton className={classes.icon}>
                                    {
                                        <HelpIcon/>
                                    }
                                </IconButton>
                            </a>
                            <div className={cx(styles["divide"])}/>
                            <IconButton
                                className={classes.icon}
                                onClick={this.onCancel}
                            >
                                <CloseIcon/>
                            </IconButton>
                        </div>
                    </AppBar>
                </DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <div className={classes.advertiserBody}>
                        {(!loaded && advertiserId) && (
                            <CircularProgress />
                        )}
                        {(loaded || !advertiserId) &&
                        <AdvertiserContent
                            displayMultiMarkets={displayMultiMarkets}
                            edit={!!advertiserId}
                            next={this.onNext}
                            back={this.onBack}
                            cancel={this.onCancel}
                            advertiser={this.advertiser}
                            getStation={getStationSaga}
                            updateAdvertiser={updateAdvertiser}
                            onAddAdvertiser={this.handleAdvertiserCreate}
                            onUpdateAdvertiser={this.handleAdvertiserUpdate}
                            extra={{ attributionFolder }}
                            engineSearch={engineSearch}
                            apiRoot={apiRoot}
                            urlApi={urlApi}
                            toggleFolderModal={toggleFolderModal}
                            editingFolder={editingFolder}
                            sessionToken={sessionToken}
                            roles={roles}
                            appSetting={appSetting}
                            reloadFilePicker={reloadFilePicker}
                            title={advertiserId ? editAdvertiserTitle : newAdvertiserTitle}
                            isSendInvite={isSendInvite}
                            emailTemplate={emailTemplate}
                        />
                        }
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

export default Advertiser;
